import { SubChartType, STGrouping } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';
import { BaseSubChart } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/base-sub-chart';
import { PresetChartType } from '../chart-presets/const';
import type { ILineChartSeries } from '../../Interface/chart-v3/sub-chart/line-chart.interface';
import type { ILineChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';

export class LineChart extends BaseSubChart implements ILineChart {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData): void {
        this.convertSubChartUiToSdkByType(SubChartType.LineChart, uiData, sdkData, rawUiData);
    }

    public type = SubChartType.LineChart;
    /**
     * 是否展示标记
     */
    public marker?: boolean;
    /**
     * 是否平滑曲线
     */
    public smooth?: boolean;
    public grouping?: STGrouping;

    public declare series: ILineChartSeries[];

    public getPresetChartType(): PresetChartType {
        if (this.marker) {
            switch (this.grouping) {
                case STGrouping.stacked:
                    return PresetChartType.LINE_STACKED_WITH_POINT;
                case STGrouping.percentStacked:
                    return PresetChartType.LINE_PERCENT_STACKED_WITH_POINT;
                default:
                    return PresetChartType.LINE_STANDARD_WITH_POINT;
            }
        } else {
            switch (this.grouping) {
                case STGrouping.stacked:
                    return PresetChartType.LINE_STACKED;
                case STGrouping.percentStacked:
                    return PresetChartType.LINE_PERCENT_STACKED;
                default:
                    return PresetChartType.LINE_STANDARD;
            }
        }
    }
}

